import { styled } from 'parkdepot-shared/theme'

export const Title = styled('div', ({ $theme }) => ({
    fontSize: '2.2rem',
    fontWeight: 700,
    lineHeight: '3.2rem',
    marginBottom: '0.8rem'
}))
